import clsx from 'clsx'
import React, {useContext} from 'react'
import ClearableSelect from 'components/clearable-select'
import MenuItem from '@mui/material/MenuItem'

import {TeacherContext} from 'teacher/context'

export default function SubjectFilter (props) {

  const {classes, onChange} = props
  const context = useContext(TeacherContext)
  const {subjects, translate} = context

  return (
    <ClearableSelect
      id="question-bank-subject-filter"
      className={clsx(classes.select, "subject")}
      value={context.query.subject || ""}
      caption={translate('subject_label')}
      onChange={onChange}
    >
      {subjects.map((subject, key) => (<MenuItem value={subject.id} key={key}>{subject.name}</MenuItem>))}
    </ClearableSelect>
  )
}
